import Signup from "./scripts/app.js";

document.addEventListener(
  "DOMContentLoaded",
  function(event) {
    const blocks = document.querySelectorAll(".block-signup");

    if (0 !== blocks.length) {
      blocks.forEach(block => {
        const blockId = block.dataset.block;
        const data = window[blockId].data;

        new Signup(data);
      });
    }
  },
  false
);

/**
 * Used for redirecting user to thank-you page
 * @see https://developers.pandadoc.com/v1/reference#section-embedded-document-javascript-events
 */
var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent",
  messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

window[eventMethod](
  messageEvent,
  function(e) {
    if (e && e.data) {
      try {
        var modal = document.getElementById("signup-section-agreement-iframe");
        var message = JSON.parse(e.data);
        if (message && message.event) {
          switch (message.event) {
            case "session_view.document.completed":
              modal.style.display = "none";

              setTimeout(function() {
                window.location.href = window.location.origin + window.location.pathname.replace(/\/?$/, "/") + "thank-you";
              }, 100);

              break;
          }
        }
      } catch (e) {
        // console.log( e );
      }
    }
  },
  false
);
